<template>
  <div
    v-if="!$route.meta.dummycofocus"
    class="corenav"
    :style="$route.meta.isRotater ? 'background-color: black;' : ''"
  >
    <router-link
      to="/"
      class="left"
      :style="$route.meta.isRotater ? 'color: white;' : ''"
      >sphinx.</router-link
    >
    <router-link
      v-if="$route.meta.isVisualizer"
      class="toKanbans"
      to="/visualizers"
      >&#9754; To all visualizers</router-link
    >
    <router-link v-if="$route.meta.isKanban" class="toKanbans" to="/kanbans"
      >&#9754; To all kanbans</router-link
    >
    <div
      class="right"
      @click="logoutBeast"
      :style="
        $route.meta.isRotater ? 'background-color: black; color: white;' : ''
      "
    >
      exit
    </div>
  </div>
</template>

<script>
import auth from "../api/auth";

export default {
  name: "CoreNav",
  methods: {
    async logoutBeast() {
      try {
        const response = await auth.logout();
        console.log(response);

        // if (response.data.success) {
        //   window.location.replace("/");
        // }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
.corenav {
  width: 100%;
  display: flex;
  padding: 5px;
  align-items: center;
}

.corenav .left {
  display: block;
  cursor: pointer;
  color: black;
  text-decoration: none;
}

.corenav .right {
  margin-left: auto;
  margin-left: auto;
  padding: 5px;
  background-color: silver;
  cursor: pointer;
}
.toKanbans {
  margin-left: 20px;
  margin-right: 10px;
  font-size: 14px;
}
</style>